/**
 * API client for dealer groups — the canonical home of the DealerGroupOption
 * shape. Every surface that lists dealer groups (the top-bar switcher context,
 * HQ Announcements, Photo Configuration) imports the interface and fetcher
 * from here. Mirrors DealerGroupOption in backend/schemas.py, served by
 * GET /dealer-groups (backend/routers/dealer_plates.py).
 */
import { API } from "../config/api"

const TOKEN_KEY = "invi_token"

export interface DealerGroupOption {
  id: number
  name: string
  slug: string
  /** The group's website by name, null when none is configured. */
  website_domain: string | null
}

const authHeaders = (): HeadersInit => {
  const token = localStorage.getItem(TOKEN_KEY)
  return token
    ? { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
    : { "Content-Type": "application/json" }
}

async function handleResponse<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const data = await res.json().catch(() => null)
    throw new Error(data?.detail || `Request failed (${res.status})`)
  }
  return res.json() as Promise<T>
}

export async function fetchDealerGroups(): Promise<DealerGroupOption[]> {
  const res = await fetch(`${API.baseUrl}${API.endpoints.dealerGroups}`, {
    headers: authHeaders(),
  })
  return handleResponse<DealerGroupOption[]>(res)
}
